import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
//import Poll from 'react-poll';
import 'react-calendar/dist/Calendar.css';
import Swal from 'sweetalert2';
import Loader from '../Loader/Loader';
import { getTokenInfo } from '../../UseToken';
import Hosts from '../../Hosts';
import { Link } from 'react-router-dom';
import { reqGET, simpleAxiosGet } from '../../Utils';
import { color } from '../WEBContent/Color';
import { icon } from '../WEBContent/Icon';
import { language } from './Language';
import { set } from 'core-js/core/dict';

export default function Agenda() {
  const [isLoading, setLoading] = useState(true);
  const [lang, set_lang] = useState('pt');
  const [userId, setUserId] = useState(null);

  const [currentFilter, setCurrentFilter] = useState('all');
  const [filterType, setFilterType] = useState('all');

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(new Date());

  const [tasks, setTasks] = useState([]);
  const [visibleTasks, setVisibleTasks] = useState([]);
  const [futureTasks, setFutureTasks] = useState([]);

  const [feriados, setFeriados] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [eventos, setEventos] = useState([]);

  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  console.log('Eventos:', eventos);

  const handleRowClick = (id) => {
    document.getElementById("c_" + id)?.click();
  };

  const priorityColors = {
    normal: color.corNormal.hexa,
    naoUrgente: color.corNaoUrgente.rgb,
    poucoUrgente: color.corPoucoUrgente.rgb,
    urgente: color.corUrgente.hexa,
    critica: color.corCritica.rgb
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case '1': return priorityColors.normal;
      case '2': return priorityColors.naoUrgente;
      case '3': return priorityColors.poucoUrgente;
      case '4': return priorityColors.urgente;
      case '5': return priorityColors.critica;
      default: return 'rgb(128, 128, 128)';
    }
  };

  const getPrioridade = (priority) => {
    switch (String(priority).toLowerCase()) {
      case "1":
      case "normal":
        return { color: priorityColors.normal, fontWeight: '600' };

      case "2":
      case "naoUrgente":
      case "não urgente":
        return { color: priorityColors.naoUrgente, fontWeight: '600' };

      case "3":
      case "poucoUrgente":
      case "pouco urgente":
        return { color: priorityColors.poucoUrgente, fontWeight: '600' };

      case "4":
      case "urgente":
        return { color: priorityColors.urgente, fontWeight: '600' };

      case "5":
      case "critica":
      case "crítica":
        return { color: priorityColors.critica, fontWeight: '600' };

      default:
        return { color: "rgb(128, 128, 128)" };
    }
  };

  const getEstadoStyle = (estado, lang) => {
    const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

    switch (estadoLabel) {
      case 'Concluído':
      case 'Completed':
        return { color: color.corVerde.rgb, fontWeight: '600' }; // Verde
      case 'Em Progresso':
      case 'In Progress':
        return { color: color.corNormal.rgb, fontWeight: '600' }; // Azul
      case 'Em Execução':
      case 'In execution':
        return { color: color.corUrgente.rgb, fontWeight: '600' }; // Laranja
      case 'Pendente':
      case 'Pending':
        return { color: color.corCritica.rgb, fontWeight: '600' }; // Vermelho
      case 'A Iniciar':
      case 'To Start':
        return { color: color.corAmarela.rgb3, fontWeight: '600' }; // Amarelo
      case 'Em Revisão':
      case 'Under Review':
        return { color: color.corRoxa.rgb, fontWeight: '600' }; // Roxo
      case 'Cancelado':
      case 'Canceled':
        return { color: color.corVermelha.rgb, fontWeight: '600' }; // Cinza
      default:
        return { color: color.cor4.rgb, fontWeight: '600' }; // Cinza Claro
    }
  };

  const FilterButton = ({ active, onClick, color, label }) => (
    <button
      onClick={onClick}
      className={`
      w-full block px-3 py-1.5 rounded-md
      transition-all duration-300
      ${active ? "text-white" : "text-black bg-gray-100 hover:bg-gray-200"}
    `}
      style={active ? { backgroundColor: color } : {}}
    >
      {label}
    </button>
  );

  // ---------------- EVENTOS ----------------
  const eventDetails = (event) => {
    setSelectedEvent(event);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const details = [
      {
        label: lang === "pt" ? "Título" : "Title",
        value: event.extendedProps?.title?.[0]?.pt || event.extendedProps?.name || "—",
      },
      {
        label: lang === "pt" ? "Tipo de Evento" : "Event Type",
        value: event.extendedProps?.event_type?.name || "—",
      },
      {
        label: lang === "pt" ? "Data" : "Date",
        value: formatDate(event.extendedProps?.date),
      },
      {
        label: lang === "pt" ? "Hora" : "Time",
        value: event.extendedProps?.time || (lang === "pt" ? "Dia todo" : "All day"),
      },
      {
        label: lang === "pt" ? "Localização" : "Location",
        value: event.extendedProps?.location || "—",
      },
      {
        label: lang === "pt" ? "Prioridade" : "Priority",
        value: event.extendedProps?.prioridade || "—",
      },
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value: Array.isArray(event.extendedProps?.description)
          ? event.extendedProps.description.map((d) => d.pt || d.en).join("<br/>")
          : event.extendedProps?.description || "—",
      },
    ];

    Swal.fire({
      title: `
      <div style="display:flex; justify-content:center; align-items:center; gap:12px;">
        <h2 style="font-size:1.5rem; font-weight:600; margin:0;">
          ${event.extendedProps?.title?.[0]?.pt || "Evento"}
        </h2>
      </div>
    `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="margin-top:1.5rem; display:flex; justify-content:center; gap:12px;">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>
        <button id="goToEvent" class="btn btn-primary">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToEvent")
          .addEventListener("click", () => {
            Swal.close();
            handleRowClick(event.id);
          });
      },
    });
  };

  // ---------------- TAREFAS ----------------
  const taskDetails = (task) => {
    setSelectedTask(task);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const estado = task.extendedProps?.estado;
    const estadoLabel =
      lang === "en" ? estado?.labelEn || "—" : estado?.labelPt || "—";
    const estadoStyle = estado ? getEstadoStyle(estado, lang) : {};

    const details = [
      {
        label: lang === "pt" ? "Tipo" : "Type",
        value: task.type || (lang === "pt" ? "Não definido" : "Undefined"),
      },
      {
        label: lang === "pt" ? "Início" : "Start",
        value: formatDate(task.extendedProps?.data_inicio),
      },
      ...(task.extendedProps?.data_limite
        ? [
          {
            label: lang === "pt" ? "Fim" : "End",
            value: formatDate(task.extendedProps?.data_limite),
          },
        ]
        : []),
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value:
          task.description ||
          task.extendedProps?.description ||
          (lang === "pt" ? "Nenhuma descrição" : "No description"),
      },
      /*
      {
        label: lang === "pt" ? "Estado" : "Status",
        value: `<span style="color:${estadoStyle.color}; font-weight:${estadoStyle.fontWeight};">
                ${estadoLabel}
              </span>`,
      },
      */
    ];

    Swal.fire({
      title: `
          <div style="display:flex; justify-content:center; align-items:center; gap:12px;">
            <h2 style="font-size:1.5rem; font-weight:600; margin:0;">
              ${task.title} 
            </h2>    
            -   
            <span style="font-size:1.5rem; font-weight:600; margin:0; color:${estadoStyle.color};">
              ${estadoLabel}
            </span>
          </div>
        `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="
        margin-top:1.5rem; 
        display:flex; 
        justify-content:center; 
        gap:12px;
      ">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>

        <button id="goToTask" class="btn btn-secondary">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToTask")
          .addEventListener("click", () => {
            Swal.close();
            handleRowClick(task.id);
          });
      },
    });
  };

  // ---------------- TICKETS ----------------
  const ticketDetails = (ticket) => {
    setSelectedTicket(ticket);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const details = [
      {
        label: lang === "pt" ? "Título" : "Title",
        value:
          ticket.title ||
          ticket.extendedProps?.name ||
          (lang === "pt" ? "Sem título" : "No title"),
      },
      {
        label: lang === "pt" ? "Tipo" : "Type",
        value: ticket.type || (lang === "pt" ? "Não definido" : "Undefined"),
      },
      {
        label: lang === "pt" ? "Departamento" : "Department",
        value:
          ticket.extendedProps?.departamentoGrupo ||
          ticket.extendedProps?.departamento ||
          "—",
      },
      {
        label: lang === "pt" ? "Estado" : "Status",
        value: ticket.extendedProps?.estado || (lang === "pt" ? "Aberto" : "Open"),
      },
      {
        label: lang === "pt" ? "Data" : "Date",
        value: formatDate(ticket.extendedProps?.date),
      },
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value: Array.isArray(ticket.extendedProps?.description)
          ? ticket.extendedProps.description.map((d) => d.pt || d.en).join("<br/>")
          : ticket.extendedProps?.description || "—",
      },
    ];

    Swal.fire({
      title: `
      <h2 style="font-size:1.5rem; font-weight:600; margin:0; color:${ticket.color};">
        ${ticket.title || ticket.extendedProps?.name}
      </h2>
    `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="margin-top:1.5rem; display:flex; justify-content:center; gap:12px;">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>
        <button id="goToTicket" class="btn btn-success">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToTicket")
          .addEventListener("click", () => {
            Swal.close();
            handleRowClick(ticket.id);
          });
      },
    });
  };

  // ---------------- CALENDAR STYLES ----------------
  const calendarStyles = `
  .custom-calendar {
    width: 100%;
    max-width: 100%;
    border: none;
    font-size: 1.2rem;
  }

  /* Navigation (month/year buttons) */
  .custom-calendar .react-calendar__navigation button {
    color: #222;
    min-width: 44px;
    background: none;
    font-size: 1.1rem;
    margin: 2px;
    border-radius: 8px;
    transition: background 0.2s;
    font-weight: 600;
  }
  .custom-calendar .react-calendar__navigation button:hover {
    background: #d9edf7; /* stronger hover */
  }

  /* Weekday labels */
  .custom-calendar .react-calendar__month-view__weekdays {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.9rem;
    color: #333;
  }

  /* Each tile (day cell) */
  .custom-calendar .react-calendar__tile {
    display: flex;
    flex-direction: column;      
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 5px;
    border-radius: 12px;
    transition: background 0.2s ease, color 0.2s ease;
    position: relative;
    font-weight: 500;
    color: #222;
  }

  /* Active (selected) day */
  .custom-calendar .react-calendar__tile--active {
    background: #54B4D3;
    color: #fff;           
    font-weight: 700;
    border-radius: 12px;
  }

  /* Hover effect */
  .custom-calendar .react-calendar__tile:hover {
    background: #b3e5fc;  
    cursor: pointer;
  }

  /* Today highlight */
  .custom-calendar .react-calendar__tile--now {
    background: #ffecb3;   
    border: 2px solid #f9a825; 
    font-weight: 700;
    color: #222;
    border-radius: 12px;
  }

  /* Disabled tiles (weekends) */
  .custom-calendar .react-calendar__tile:disabled {
    background: #f5f5f5;
    color: #aaa;
    cursor: not-allowed;
  }

  /* Custom wrapper inside each tile */
  .custom-calendar .tile-inner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
  }

  /* Day number styling */
  .custom-calendar .day-number {
    font-weight: bold;
    font-size: 1rem;
    align-self: flex-start;  
  }

  /* Bottom icons/content */
  .custom-calendar .day-icons {
    font-size: 0.85rem;
    color: #444;
    margin-top: auto;
    text-align: center;
    width: 100%;
  }
  `;

  const isSameDay = (d1, d2) =>
    d1 && d2 &&
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  const parseLocalDate = (dateString) => {
    if (!dateString) return null;
    const d = new Date(dateString);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const formatDate = (d) => {
    if (!d) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        set_lang(localStorage.getItem("lang"));

        const storedData = localStorage.getItem("token");
        if (!storedData) return;
        const data = JSON.parse(storedData);
        if (!data.user_info) return;

        const userId = data.user_info.id;
        setUserId(userId);

        setLoading(true);

        // buscar tarefas, tickets e feriados
        const [tarefaResponse, ticketResponse, eventoResponse] = await Promise.all([
          reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`),
          reqGET(`${Hosts.SIMCore_API}/intranet/suporte/${getTokenInfo().companycode}`),
          reqGET(`${Hosts.SIMCore_API}/evento/type/${getTokenInfo().companycode}/evento`),
        ]);

        // ----------------- TAREFAS -----------------
        const userTasks = tarefaResponse.data.filter(
          (task) =>
            Array.isArray(task.info.responsaveis) &&
            task.info.responsaveis.some((r) => r.value === userId)
        );

        const formattedTasks = userTasks
          .filter((task) => task.info.status?.value !== "Cancelado")
          .map((task) => ({
            id: task.id,
            title: task.info.name || "Sem título",
            color: getPriorityColor(task.info.prioridade?.value),
            extendedProps: {
              ...task.info,
              data_inicio: task.info.data_inicio,
              data_limite: task.info.data_limite,
              dataConclusao: task.info.dataConclusao,
            },
            type: "tarefa",
          }));
        setTasks(formattedTasks);

        // ----------------- TICKETS -----------------
        const userTickets = (ticketResponse?.data || []).filter(
          (ticket) => ticket.info?.colaborador?.[0]?.value === userId
        );

        const formattedTickets = userTickets.map((ticket) => ({
          id: `ticket-${ticket.id}`,
          title: ticket.info.assunto || "Ticket sem assunto",
          color: color.corAmarela.hexa3,
          extendedProps: ticket.info,
          type: "ticket",
        }));

        setTickets(formattedTickets);

        // ----------------- EVENTOS -----------------
        const userEventos = (eventoResponse?.data || []).filter((evento) => {
          const responsaveis = evento.info?.responsaveis || [];
          const isLembrete = evento.info?.event_type?.name === "Lembrete";

          const isResponsavel =
            responsaveis.some((p) => String(p.id) === String(userId));

          const creatorId =
            Array.isArray(evento?.info?.createadBy) &&
            evento.info?.createadBy.some((c) => String(c.id) === String(userId));

          if (isLembrete) {
            return creatorId;
          }

          return responsaveis.length === 0 || isResponsavel;
        });    

        const eventos = userEventos.map((evento) => ({
          id: `evento-${evento.id}`,
          title: evento.info?.title || evento.info?.name || "Evento sem título",
          color: color.corVerde.hexa3,
          type: "evento",
          extendedProps: evento.info || {},
        }));

        setEventos(eventos);

        // ----------------- VISÍVEIS -----------------
        const filtered = formattedTasks.filter((t) => {
          if (t.extendedProps?.estado?.value === 2) return false;
          if (filterType !== "all" && t.type !== filterType) return false;
          if (filterType === "tarefa" && currentFilter !== "all") {
            if (t.extendedProps.prioridade?.value !== currentFilter) return false;
          }

          const inicio = parseLocalDate(t.extendedProps?.data_inicio);
          const limite = parseLocalDate(t.extendedProps?.data_limite);
          const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
          const sel = parseLocalDate(selectedDate);

          if (isWeekend(sel)) return false;
          if (inicio && isSameDay(inicio, sel)) return true;

          const endDate = conclusao || limite;
          if (inicio && endDate && sel > inicio && sel <= endDate) return true;

          if (conclusao && isSameDay(conclusao, sel)) return true;
          return false;
        });

        setVisibleTasks(filtered);

        // ----------------- FUTURAS (7 DIAS) -----------------
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const nextWeek = new Date(today);
        nextWeek.setDate(today.getDate() + 7);

        const futureFiltered = formattedTasks.filter((t) => {
          if (t.extendedProps?.estado?.value === 2) return false;
          if (filterType !== "all" && t.type !== filterType) return false;
          if (filterType === "tarefa" && currentFilter !== "all") {
            if (t.extendedProps.prioridade?.value !== currentFilter) return false;
          }

          const inicio = parseLocalDate(t.extendedProps?.data_inicio);
          const limite = parseLocalDate(t.extendedProps?.data_limite);

          const refDate = limite || inicio;
          if (!refDate) return false;

          return refDate > today && refDate <= nextWeek;
        });

        setFutureTasks(
          Array.from(new Map(futureFiltered.map((t) => [t.id, t])).values())
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        Swal.fire({
          title: "Erro",
          text: "Não foi possível carregar os dados",
          icon: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, filterType, currentFilter]);

  useEffect(() => {
    const fetchHolidays = async () => {
      const year = activeStartDate.getFullYear();
      const [holidayResponse] = await Promise.all([
        simpleAxiosGet(
          `https://services.sapo.pt`,
          `/Holiday/GetNationalHolidays?year=${year}`
        ),
      ]);

      const Holidays = await holidayResponse;
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(Holidays, "text/xml");
      const holidayNodes = xmlDoc.getElementsByTagName("Holiday");

      const feriadosParsed = Array.from(holidayNodes).map((node) => {
        const name = node.getElementsByTagName("Name")[0]?.textContent || "";
        const dateRaw = node.getElementsByTagName("Date")[0]?.textContent || "";

        const dateObj = new Date(dateRaw);
        const date = formatDate(dateObj);

        return { date, name };
      });

      setFeriados(feriadosParsed);
    };

    fetchHolidays();
  }, [activeStartDate]);

  /*
    const dayScheduledTasks = tasks.filter((t) => {
      const inicio = parseLocalDate(t.extendedProps?.data_inicio);
      const limite = parseLocalDate(t.extendedProps?.data_limite);
      const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
      const estado = t.extendedProps?.estado?.value;

      if (estado === 2) return false;
      if (!inicio) return false;

      const endDate = conclusao || limite;
      if (!endDate) return false;

      const inWindow =
        date > inicio && date <= endDate && formatDate(date) === dayIso;

      return inWindow && date <= today;
    });
    */

  const tileContent = ({ date, view }, filterType, currentFilter) => {
    if (view !== "month") return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dayIso = formatDate(date);

    // ---------------- FERIADOS ----------------
    const feriado = feriados.find((f) => f.date === dayIso);
    if (feriado) {
      return (
        <div
          style={{
            background: "linear-gradient(135deg, rgba(220,53,69,0.15), rgba(220,53,69,0.05))",
            color: "#b91c1c",
            fontSize: "0.75rem",
            textAlign: "center",
            borderRadius: "8px",
            padding: "6px 8px",
            fontWeight: 600,
            lineHeight: 1.3,
            maxWidth: "90%",
            margin: "4px auto",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            border: "1px solid rgba(220,53,69,0.25)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={feriado.name}
        >
          {feriado.name}
        </div>
      );
    }

    if (isWeekend(date)) return null;

    // ---------------- FILTRO BASE ----------------
    const filterItems = (list, typeCheck = null) => {
      return list.filter((t) => {
        if (filterType !== "all" && t.type !== filterType) return false;
        if (typeCheck && t.type !== typeCheck) return false;

        if (t.type === "tarefa" && currentFilter !== "all") {
          const prioridade = t.extendedProps?.prioridade;
          if (!prioridade) return false;
          if (String(prioridade.value) !== String(currentFilter)) return false;
        }
        return true;
      });
    };

    // ---------------- EVENTOS ----------------
    const dayEventos = filterItems(
      eventos.filter((ev) => {
        const d = ev.extendedProps?.date;
        if (!d) return false;
        return formatDate(parseLocalDate(d)) === dayIso;
      }),
      "evento"
    );

    // ---------------- TASKS ----------------
    const dayCreatedTasks = filterItems(
      tasks.filter((t) => {
        const inicio = parseLocalDate(t.extendedProps?.data_inicio);
        return inicio && formatDate(inicio) === dayIso;
      }),
      "tarefa"
    );

    const dayScheduledTasks = filterItems(
      tasks.filter((t) => {
        const inicio = parseLocalDate(t.extendedProps?.data_inicio);
        const limite = parseLocalDate(t.extendedProps?.data_limite);
        const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
        const estado = t.extendedProps?.estado?.value;

        if (dayIso !== formatDate(today)) return false;
        if (estado === 2) return false;
        if (!inicio) return false;

        const endDate = conclusao || limite;
        return endDate && inicio <= today && today <= endDate;
      }),
      "tarefa"
    );

    const dayCompletedTasks = filterItems(
      tasks.filter((t) => {
        const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
        const estado = t.extendedProps?.estado?.value;
        return conclusao && formatDate(conclusao) === dayIso && estado === 6;
      }),
      "tarefa"
    );

    const futureCreatedTasks = filterItems(
      futureTasks.filter((t) => {
        const inicio = parseLocalDate(t.extendedProps?.data_inicio);
        return inicio && formatDate(inicio) === dayIso && inicio > today;
      }),
      "tarefa"
    );

    const expiredTasks = filterItems(
      tasks.filter((t) => {
        const limite = parseLocalDate(t.extendedProps?.data_limite);
        const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
        const estado = t.extendedProps?.estado?.value;

        return (
          limite &&
          formatDate(limite) === dayIso &&
          limite < today &&
          estado !== 6 &&
          !conclusao
        );
      }),
      "tarefa"
    );

    // ---------------- TICKETS ----------------
    const dayTickets = filterItems(
      tickets.filter((t) => {
        const d = t.extendedProps?.date;
        if (!d) return false;
        return formatDate(parseLocalDate(d)) === dayIso;
      }),
      "ticket"
    );

    // ---------------- CONTADORES ----------------
    const createdCount = dayCreatedTasks.length;
    const scheduledCount = dayScheduledTasks.length;
    const completedCount = dayCompletedTasks.length;
    const futureCount = futureCreatedTasks.length;
    const expiredCount = expiredTasks.length;
    const ticketsCount = dayTickets.length;
    const eventosCount = dayEventos.length;

    if (
      !createdCount &&
      !scheduledCount &&
      !completedCount &&
      !futureCount &&
      !expiredCount &&
      !ticketsCount &&
      !eventosCount
    ) {
      return null;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 4,
        }}
      >
        {/* Icons dos Eventos */}
        {eventosCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.evento.className} style={icon.evento.style}></i>
            <span>{eventosCount}</span>
          </div>
        )}

        {/* Icons das Tarefas */}
        {createdCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.criar.className} style={icon.criar.style}></i>
            <span>{createdCount}</span>
          </div>
        )}
        {scheduledCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.agendado.className} style={icon.agendado.style}></i>
            <span>{scheduledCount}</span>
          </div>
        )}
        {completedCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.concluida.className} style={icon.concluida.style}></i>
            <span>{completedCount}</span>
          </div>
        )}
        {futureCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.criar.className} style={icon.criar.style}></i>
            <span>{futureCount}</span>
          </div>
        )}
        {expiredCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.expirada.className} style={icon.expirada.style}></i>
            <span>{expiredCount}</span>
          </div>
        )}

        {/* Icons dos Tickets */}
        {ticketsCount > 0 && (
          <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
            <i className={icon.ticket.className} style={icon.ticket.style}></i>
            <span>{ticketsCount}</span>
          </div>
        )}
      </div>
    );
  };

  if (isLoading) return <Loader />;

  return (
    <main id="agenda-view" style={{ padding: '20px 0 50px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <div className="sticky-top" style={{ top: '20px' }}>
              <h3 className="text-center mb-3">{language[lang].filtros}</h3>
              <div className="d-flex flex-column gap-2">
                <FilterButton active={filterType === 'all'} onClick={() => setFilterType('all')} color={color.corSecundaria.rgb} label={language[lang].all} />
                <FilterButton active={filterType === 'evento'} onClick={() => setFilterType('evento')} color={color.corVerde.hexa3} label={language[lang].eventos} />
                <FilterButton active={filterType === 'tarefa'} onClick={() => setFilterType('tarefa')} color={color.corRoxa.hexa} label={language[lang].tasks} />
                <FilterButton active={filterType === 'ticket'} onClick={() => setFilterType('ticket')} color={color.corAmarela.hexa3} label={language[lang].tickets} />
              </div>
              {filterType === 'tarefa' && (
                <div className="mt-4 d-flex flex-column gap-2">
                  <FilterButton active={currentFilter === 'all'} onClick={() => setCurrentFilter('all')} color={color.corSecundaria.rgb} label={language[lang].all} />
                  <FilterButton active={currentFilter === '1'} onClick={() => setCurrentFilter('1')} color={priorityColors.normal} label={language[lang].normal} />
                  <FilterButton active={currentFilter === '2'} onClick={() => setCurrentFilter('2')} color={priorityColors.naoUrgente} label={language[lang].nao_urgente} />
                  <FilterButton active={currentFilter === '3'} onClick={() => setCurrentFilter('3')} color={priorityColors.poucoUrgente} label={language[lang].pouco_urgente} />
                  <FilterButton active={currentFilter === '4'} onClick={() => setCurrentFilter('4')} color={priorityColors.urgente} label={language[lang].urgente} />
                  <FilterButton active={currentFilter === '5'} onClick={() => setCurrentFilter('5')} color={priorityColors.critica} label={language[lang].critica} />
                </div>
              )}
            </div>
          </div>

          {/* Listagem */}
          <div className="col-md-6">
            <div className="bg-white rounded-1xl shadow-sm p-4">
              <div style={{ marginTop: 12 }}>
                <h3>{selectedDate.toLocaleDateString()}</h3>

                {/* ---------------- Feriados ---------------- */}
                <div style={{ marginTop: 20 }}>
                  {(() => {
                    const dayIso = formatDate(selectedDate);
                    const feriado = feriados.find((f) => f.date === dayIso);

                    if (feriado) {
                      return (
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, rgba(220,53,69,0.15), rgba(220,53,69,0.05))",
                            color: "#b91c1c",
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            padding: "8px 12px",
                            borderRadius: "8px",
                            marginBottom: "12px",
                            border: "1px solid rgba(220,53,69,0.25)",
                            textAlign: "center",
                          }}
                          title={feriado.name}
                        >
                          {language[lang].feriado} - {feriado.name}
                        </div>
                      );
                    }
                  })()}
                </div>

                {/* ---------------- EVENTOS ---------------- */}
                {eventos
                  .filter((t) => {
                    if (t.type !== "evento") return false;
                    return formatDate(selectedDate) === t.extendedProps?.date;
                  })
                  .map((t) => (
                    <div
                      key={t.id}
                      onClick={() => eventDetails(t)}
                      style={{
                        padding: "12px 14px",
                        borderLeft: `4px solid ${t.color || "#6f42c1"}`,
                        marginBottom: 12,
                        background: color.cor3.rgb,
                        cursor: "pointer",
                        borderRadius: 8,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 3px 6px rgba(0,0,0,0.12)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)";
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        {/* Coluna esquerda */}
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 15 }}>
                            {t.extendedProps?.title?.[0]?.pt || "Evento sem título"}
                          </div>
                          <div style={{ fontSize: 12, color: "#888" }}>
                            {t.extendedProps?.event_type?.name || "Evento"}
                          </div>
                          {t.extendedProps?.location && (
                            <div style={{ fontSize: 12, color: "#555" }}>
                              📍 {t.extendedProps.location}
                            </div>
                          )}
                        </div>

                        {/* Coluna direita */}
                        <div style={{ textAlign: "right", minWidth: 100 }}>
                          {t.extendedProps?.time && (
                            <div style={{ fontSize: 13, color: "#222", marginBottom: 2 }}>
                              {t.extendedProps.time}
                            </div>
                          )}
                          {t.extendedProps?.prioridade && (
                            <div style={{ fontSize: 12, ...getPrioridade(t.extendedProps?.prioridade, lang) }}>
                              {t.extendedProps.prioridade}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                {/* ---------------- TAREFAS ---------------- */}
                {visibleTasks
                  .filter((t) => t.type === "tarefa")
                  .map((t) => (
                    <div
                      key={t.id}
                      onClick={() => taskDetails(t)}
                      style={{
                        padding: "12px 14px",
                        borderLeft: `4px solid ${t.color}`,
                        marginBottom: 12,
                        background: color.cor3.rgb,
                        cursor: "pointer",
                        borderRadius: 8,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 3px 6px rgba(0,0,0,0.12)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)";
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 15 }}>{t.title}</div>
                          <div style={{ fontSize: 12, color: "#888" }}>{language[lang].task}</div>
                        </div>
                        <div style={{ textAlign: "right", minWidth: 100 }}>
                          <div style={{ fontSize: 13 }}>
                            {t.extendedProps?.hours || "O dia todo"}
                          </div>
                          <div style={{ fontSize: 12, ...getEstadoStyle(t.extendedProps?.estado, lang) }}>
                            {lang === "en"
                              ? t.extendedProps?.estado?.labelEn
                              : t.extendedProps?.estado?.labelPt || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                {/* ---------------- TICKETS ---------------- */}
                {tickets
                  .filter((t) => t.type === "ticket")
                  .map((t) => (
                    <div
                      key={t.id}
                      onClick={() => ticketDetails(t)}
                      style={{
                        padding: "12px 14px",
                        borderLeft: "4px solid #28a745",
                        marginBottom: 12,
                        background: color.cor3.rgb,
                        cursor: "pointer",
                        borderRadius: 8,
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 15 }}>{t.title}</div>
                          <div style={{ fontSize: 12, color: "#888" }}>{language[lang].ticket}</div>
                        </div>
                        <div style={{ textAlign: "right", minWidth: 100 }}>
                          <div style={{ fontSize: 12, color: "#555" }}>
                            {t.extendedProps?.estado || "Aberto"}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Calendar */}
          <div className="col-md-4">
            <style>{calendarStyles}</style>
            <div className="sticky-top" style={{ top: "20px" }}>
              <Calendar
                onClickDay={(d) => setSelectedDate(d)}
                value={selectedDate}
                activeStartDate={activeStartDate}
                onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)}
                tileContent={(props) => tileContent(props, filterType, currentFilter)}
                className="custom-calendar"
                locale={lang}
                calendarType="US"
                tileDisabled={({ date }) => {
                  const day = date.getDay();
                  return day === 0 || day === 6;
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="row"
          style={{ justifyContent: 'end', alignItems: 'end', marginLeft: '10px', marginTop: '20px' }}
        >
          <div className="col-md-4">
            <div style={{ marginTop: 8, fontSize: 14 }}>

              {/* Criadas */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.criar.className} style={icon.criar.style}></i>
                <span>{language[lang].tarefas_criadas}</span>
              </div>

              {/* Agendadas */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.agendado.className} style={icon.agendado.style}></i>
                <span>{language[lang].tarefas_agendadas}</span>
              </div>

              {/* Concluídas */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.concluida.className} style={icon.concluida.style}></i>
                <span>{language[lang].tarefas_concluidas}</span>
              </div>

              {/* Expiradas */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.expirada.className} style={icon.expirada.style}></i>
                <span>{language[lang].tarefas_expiradas}</span>
              </div>

              {/* Eventos */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.evento.className} style={icon.evento.style}></i>
                <span>{language[lang].eventos}</span>
              </div>

              {/* Tickets */}
              <div style={{ marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <i className={icon.ticket.className} style={icon.ticket.style}></i>
                <span>{language[lang].tickets}</span>
              </div>

            </div>
          </div>
        </div>
      </div>

      {selectedEvent && (
        <Link
          id={"c_" + selectedEvent.id}
          className="d-none"
          to={{
            pathname: "evento_view",
            state: { item: selectedEvent, operation: "view" },
          }}
          replace
        >
          <i className="bi bi-eye"></i>
        </Link>
      )}

      {selectedTask && (
        <Link
          id={"c_" + selectedTask.id}
          className="d-none"
          to={{
            pathname: "intranet_tarefa_view",
            state: { item: selectedTask, operation: "view" },
          }}
          replace
        >
          <i className="bi bi-eye"></i>
        </Link>
      )}

      {selectedTicket && (
        <Link
          id={"c_" + selectedTicket.id}
          className="d-none"
          to={{
            pathname: "ticket_regist",
            state: { item: selectedTicket, operation: "regist" },
          }}
          replace
        >
          <i className="bi bi-eye"></i>
        </Link>
      )}

    </main>
  );
}
